// src/components/Section1.jsx
import React from "react";
import "./section1.css";
import { useTranslation } from "react-i18next";
const Section1 = () => {
    const { t } = useTranslation();
    return (
        <section className="section1">
<div className="section1__inner">
  {/* Heading */}
  <div style={{textAlign:"center", marginTo: "15px", marginBottom: "15px"}}>
    <h2 className="section1__title">
{t("sec1c")}
    </h2>
  </div>

    {/* Steps */}
  <div className="section1__steps">

    <div className="section1__step"  onClick={() => (window.location.href = "/saver")}>
      <div className="section1__step-icon">1</div>
      <h3 className="section1__step-title">  {t("sec1-1ch")}  </h3>
      <p className="section1__step-text">
{t("sec1-1ca")} 
     </p>
     <p style={{marginTop: "10px"}}>{t("sec1-1cb")} </p>
    </div>

    <div className="section1__step"  onClick={() => (window.location.href = "/1")}>
      <div className="section1__step-icon">2</div>
      <h3 className="section1__step-title"> {t("sec1-2ch")}   </h3>
      <p className="section1__step-text">
     {t("sec1-2ca")} 
      </p>
<p style={{marginTop: "10px"}}>{t("sec1-2cb")} </p>
    </div>

    <div className="section1__step">
      <div className="section1__step-icon">3</div>
      <h3 className="section1__step-title">  {t("sec1-3ch")}  </h3>
      <p className="section1__step-text">
{t("sec1-3ca")} </p>
      <p style={{marginTop: "10px"}}>{t("sec1-3cb")} </p>
    </div>

    <div className="section1__step">
      <div className="section1__step-icon">4</div>
 <h3 className="section1__step-title">    {t("sec1-4ch")}  </h3>
<p className="section1__step-text">
 {t("sec1-4ca")}  </p>
  <p style={{marginTop: "10px"}}>{t("sec1-4cb")} </p>
    </div>

  </div>




</div>

        </section>
    );
};

export default Section1;
